import styled from 'styled-components'
import {
  Row,
  Tab,
  TabContent,
  Table,
} from '@components/ApparelSizeTable/ApparelSizeTable.styles'
import { Size } from '@components/ShoeSizeTable/ShoeSizeTable.styles'

export const TableWrap = styled.div<{ fullWidth?: boolean }>`
  min-width: 18rem;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '60%')};
  }
`

export const AccessoryTab = styled(Tab)`
  @media screen and (min-width: 768px) {
    width: auto;
    padding: 0.8rem 1rem;
  }
`

export const AccessoryTabContent = styled(TabContent)`
  padding: 1.4rem;
`

export const AccessoryTable = styled(Table)<{ mobileRotate?: boolean }>`
  flex-direction: ${({ mobileRotate }) => (mobileRotate ? 'row' : 'column')};
  gap: 0;

  @media screen and (min-width: 768px) {
    flex-direction: column;
  }
`

export const AccessoryRow = styled(Row)<{
  mobileRotate?: boolean
  nColumn: number
}>`
  position: relative;
  padding: 0;
  flex: 1;
  grid-template-columns: ${({ mobileRotate, nColumn }) =>
    mobileRotate ? '1fr' : `repeat(${nColumn}, 1fr)`};
  grid-template-rows: ${({ mobileRotate, nColumn }) =>
    mobileRotate ? `repeat(${nColumn}, 1fr)` : '1fr'};
  grid-auto-flow: ${({ mobileRotate }) => (mobileRotate ? 'column' : 'row')};
  grid-gap: 0;

  @media screen and (min-width: 768px) {
    grid-template-rows: 1fr;
    grid-template-columns: ${({ nColumn }) => `repeat(${nColumn}, 1fr)`};
    grid-auto-flow: row;
  }

  &:first-child {
    border: none;
  }

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: ${({ mobileRotate }) =>
      mobileRotate ? '0.1rem' : 'calc(100% - 7rem)'};
    height: ${({ mobileRotate }) =>
      mobileRotate ? 'calc(100% - 5rem)' : '0.1rem'};
    background: ${({ theme }) => theme.colors.secondary};

    @media screen and (min-width: 768px) {
      width: calc(100% - 9rem);
      height: 0.1rem;
    }
  }
`

export const AccessorySize = styled(Size)<{
  separator?: boolean
  start?: number
  end?: number
}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  text-transform: uppercase;
  grid-row: ${({ start, end }) => (start && end ? `${start}/${end}` : 'auto')};

  @media screen and (min-width: 768px) {
    height: 4.8rem;
    grid-row: auto;
    grid-column: ${({ start, end }) =>
      start && end ? `${start}/${end}` : 'auto'};
  }

  &:first-child {
    width: 9rem;
    height: 4.8rem;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 0.1rem;
    background: ${({ theme, separator }) =>
      separator ? theme.colors.secondary : 'transparent'};

    @media screen and (min-width: 768px) {
      width: 0.1rem;
      height: 100%;
    }
  }
`
